import auth from '@/util/auth'
import {setStore, getStore, removeStore} from '@/util/store'
import router from '@/router/router'

const user = {
  state: {
    userInfo: {},
    groupCompanyFlag: {},
    account: {},
    permission: {},
    roles: [],
    menu: [],
    companyList: [],
    currentCompany: {},
    defaultCompany:{},
    signer: {}
  },
  actions: {


    //存储个人信息
    setUserInfo({commit, state, dispatch}, data) {
      return new Promise((resolve, reject) => {
        commit('SET_USERIFNO', data);
        resolve();
      });

    },

    //添加动态路由
    setRoute({commit, state, dispatch}, data) {
      return new Promise((resolve, reject) => {
        commit('SET_ROUTE', data);
        resolve();
      });
    },

    //存储菜单
    setMenu({commit, state, dispatch}, data) {
      return new Promise((resolve, reject) => {
        commit('SET_MENU', data);
        resolve();
      });
    },

    //设置角色
    setRole({commit, state, dispatch}, data) {
      return new Promise((resolve, reject) => {
        commit('SET_ROLES', data);
        resolve();
      });
    },
    //设置权限，为控制按钮做铺垫
    setPermission({commit, state, dispatch}, data) {
      return new Promise((resolve, reject) => {
        commit('SET_PERMISSION', data);
        resolve();
      });
    },
    setSigner({commit},data){
      return new Promise((resolve,reject)=>{
        commit("SET_SIGNER",data)
        resolve()
      })
    }

  },
  mutations: {

    SET_USERIFNO: (state, user) => {
      // userinfo接口修改 后端不能提供 暂且使用companyid = 总部id
      // state.groupCompanyFlag = user.groupCompanyFlag;
    
      state.userInfo = user.userInfo;
      state.userDept = user.userDept || [];
      state.companyList = user.company;
      state.account = user.account;
      let defaultCompany = user.company.find(i => {
        return i.default == 'Y'
      })
      state.defaultCompany = user.defaultCompany 
      state.groupCompanyFlag = user.defaultCompany.companyId == 1000000000000000000
    },
    SET_SIGNER: (state,signer)=>{
      state.signer = signer
    },
    SET_ROUTE: (state, routes) => {
      router.addRoutes(routes);
    },
    SET_MENU: (state, menu) => {
      state.menu = menu;
    },

    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = {};
      permission.forEach(ele => {
        state.permission[ele] = true;
      });
    }
  }

}
export default user
